interface ICruiseRouteTypes {
  port: string;
  sailing: string;
}

export const CruiseRouteTypes: ICruiseRouteTypes = {
  port: "port",
  sailing: "sailing",
};
